import React from "react";

function Home() {
  return (
    <div>
      <h1>Welcome to ShopNest</h1>
      <p>This is the Home Page</p>
    </div>
  );
}

export default Home;
